import { PUBLIC_ROUTES } from 'src/constants/urlConstants';

export const UrlHelper = {
  getAbsoluteUrl: relativeUrl => {
    const link = document.createElement('a');
    link.href = relativeUrl;
    const absoluteUrl = link.href;
    return absoluteUrl;
  },
  getFirstLevelDomain: () => {
    const domains = window.location.hostname.split('.');
    const domainsSize = domains.length;
    const topLevelDomain = domains[domainsSize - 1];
    const applicationName = domains[domainsSize - 2];
    return `${applicationName}.${topLevelDomain}`;
  },
};

// url search example: '?FILTER="gov_id=33714503559"?agency_id=14' -> '33714503559'
export const getFilterValueFromUrlSearchParams = urlSearch => {
  if (urlSearch && typeof urlSearch === 'string') {
    const filterParam = decodeURI(urlSearch)
      .split('?')
      .find(i => i.includes('FILTER'))
      ?.replace(/"/g, '');

    return filterParam?.split('=')[filterParam?.split('=').length - 1] || '';
  }
  return '';
};

export const isPublicRoute = path => PUBLIC_ROUTES.includes(path);
